export default __webpack_public_path__ + "static/hero-bg-f9a49ba41668b8d917cd4c53ac080e1f.jpg";